import type { RidingPreferences } from '../shared/contracts.js';

/** The riding preferences in display order, shared by the sliders, results and overview. */
export const PREFERENCE_LABELS: Array<{ key: keyof RidingPreferences; title: string; detail: string }> = [
  { key: 'winding', title: 'Flowing and winding roads', detail: 'Prefer connected corners over suburban zigzags.' },
  { key: 'motorways', title: 'Avoid motorways', detail: 'Use local roads where the detour fits your allowance.' },
  { key: 'trafficLights', title: 'Avoid traffic lights', detail: 'At 10 a 4-way light is worth about 3 km of straight road; a 3-way light half that.' }
];
